import React, { useEffect, useState } from 'react';
import { downloadReportPdf } from '@src/util/reportPdf/downloadReportPdf';
import './relayOn.css';
import { Button, Checkbox, message } from 'antd';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { getScheduleReportByJobIdQuery } from '@src/util/query/scheduleReport.query';
import { getReportTemplateById } from "@src/util/query/reportTemplate.query";
import { dutyReportToTemplateMapping } from '@src/util/mobileDutyReportToTemplateMapping/mobileDutyReportToTemplateMapping';
import { wrapReportDetailForLegacyLookup } from '@src/util/reportFieldAnswers/reportFieldAnswers';
import Spinner from "@src/components/spinner";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';


const RelayOnAlarm = (job=null) => {

    const [report, setReport] = useState(null);


    const [processingPdf, setPdfProcessing] = useState(false);

    const param = useParams();




    const {data: reportData, loading: reportDataLoading, refetch: reportDataRefetch} = useQuery(getScheduleReportByJobIdQuery,{
        variables:{
            jobId: (param?.jobId || job?.jobId)
        },
        // skip: (!param?.jobId || !job?.jobId),
        fetchPolicy:'network-only'
    });

    // this layout reads reportDetail by hardcoded legacy label-slug (e.g. report?.sitename) —
    // fetch the template so wrapReportDetailForLegacyLookup can resolve those against new
    // submissions, which are keyed by instanceId instead
    const {data: templateData} = useQuery(getReportTemplateById,{
        variables:{
            templateId: dutyReportToTemplateMapping['relayOnAlarm']?.templateId
        },
        fetchPolicy:'network-only'
    });


    // drawn by wfc-server in this layout (utils/pdf/customReports/customReportPdf.ts)
    const downloadPdfFromUrl = async () => {
        setPdfProcessing(true);
        try {
            await downloadReportPdf({ jobId: param?.jobId || job?.jobId, templateId: dutyReportToTemplateMapping['relayOnAlarm']?.templateId, filename: 'Alarm Activation' });
            message.success("Report downloaded successfully");
        } catch (err) {
            message.error(err?.message || "Couldn't create the PDF. Please try again.");
        } finally {
            setPdfProcessing(false);
        }
    };

    useEffect(()=>{
        if(reportData?.getScheduleReportByJobId?.response){

            const templateFields = templateData?.getReportTemplateById?.response?.template?.reportFields?.flatMap((s)=>s?.fields||[]) || [];
            setReport(wrapReportDetailForLegacyLookup(reportData?.getScheduleReportByJobId?.response?.reportDetail, templateFields));

        }else{
            setReport(null)
        }
    },[reportData?.getScheduleReportByJobId?.response, templateData]);



   return(
    reportDataLoading?
        <div className='row-flex' style={{justifyContent:'center', alignContent:'center', alignItems:'center'}}>
            <Spinner/>
        </div>
        :
    <div>
            
            
        <div id="pdfexportBtn" style={{display:'flex', justifyContent:'right', padding:'20px',
            // position: 'sticky',
            // top: '50px',
            // background: 'white',
        }}>
                <Button disabled={processingPdf} style={{fontSize:'14px'}} onClick={downloadPdfFromUrl}>
                    {processingPdf? 
                        <Spinner/>:
                        <>
                            Download Report &nbsp;<FontAwesomeIcon icon={faDownload} />
                        </>
                    }
                </Button>
        </div>

        <div 
            style={{ 
                fontFamily: 'Arial, sans-serif', 
                fontSize: '12px', 
                maxWidth: '210mm', 
                margin: '0 auto', 
                padding: '20px',
                backgroundColor: 'white'
            }}
            id="pdfContent" 
            // style={{width: "297mm", pageBreakInside: "avoid", margin: '0 auto', maxHeight: "297mm"}}
        >


            {/* Header */}
            <div style={{ textAlign: 'center', marginBottom: '20px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>

                <div style={{width:'150px', height:'100px'}}>
                    <img src={'https://wfcrevampdoc.s3.us-east-1.amazonaws.com/customer/67a0cc8782ceb2b53bd36d1c/Customer-67a0cc8782ceb2b53bd36d1c-1754392079460-RELYON_PRIMARY_Group.svg'} />
                </div>
                <div>
                    <div style={{
                        fontSize: '22px',
                        fontWeight: 'bold',
                        margin: '0 0 5px 0',
                        textAlign: 'right',
                        borderBottom: '1px solid black'
                    }}>
                        Alarm Activation
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        margin: '0'
                    }}>
                        <div style={{
                            fontSize: '16px',
                            fontWeight: 'bold',
                            borderBottom: '1px solid black'
                        }}>
                            Report Form
                        </div>
                    </div>
                </div>


            </div>

            {/* body */}
            <div className='mb32'>
                <div className='relayOnGridSectionHead'>
                   Company Details
                </div>
                
                <table className='relayOnGrid' border={1}>
                    <tr>
                        <th>Site Name</th>
                        <td>{report?.sitename}</td>
                    </tr>
                    <tr>
                        <th>Site Address</th>
                        <td>{report?.siteaddress}</td>
                    </tr>
                    <tr>
                        <th>Post Code</th>
                        <td>{report?.postcode}</td>
                    </tr>
                    <tr>
                        <th>Date of Activation</th>
                        <td>{report?.dateofactivation}</td>
                    </tr>
                    <tr>
                        <th>Time of Call</th>
                        <td>{report?.timeofcall}</td>
                    </tr>
                    <tr>
                        <th>Time of Arrival</th>
                        <td>{report?.timeofarrival}</td>
                    </tr>
                    <tr>
                        <th>Time Left Site</th>
                        <td>{report?.timeleftsite}</td>
                    </tr>
                    <tr>
                        <th>Type of Alarm</th>
                        <td>{report?.typeofalarm}</td>
                    </tr>
                </table>
            </div>

            <div className='mb32'>
                <div className='relayOnGridSectionHead'>
                   Actions Whlist On Site
                </div>
                
                <table className='relayOnGrid' border={1}>
                    <tr>
                        <th>Officer's Comments</th>
                        <td>
                            {report?.["officer'scomments"]}
                        </td>
                    </tr>
                </table>
            </div>


            <div className='mb32'>

                <div className='relayOnGridSectionHead' style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                    <span>Pictures</span>
                </div>

                <table style={{width:'100%'}} className='relayOnGrid' border={1}>
                                    

                    {!reportDataLoading ?
                        reportData?.getScheduleReportByJobId?.response?.filesURL && Object.values(reportData?.getScheduleReportByJobId?.response?.filesURL)?.map((file)=>(

                            <tr >
                                <td>
                                    <div style={{ width:'500px', height:'600px',  cursor:'pointer', margin: 'auto', padding:'10px', overflow:'hidden' }}
                                        onClick={()=>{
                                            window.open(file, "_blank");
                                        }}
                                    >
                                        {/* Placeholder for image loading */}
                                        <img
                                            src={file}
                                            alt={"Image placeholder"}
                                            placeholder={<Spinner />}
                                            style={{ maxWidth: "100%", height: "auto" }} // Ensures responsiveness
                                        />
                                    </div>
                                </td>
                            </tr>

                        ))
                        :
                        null
                    }


                </table>

            </div>

        </div>

    </div>

   )
}

export default RelayOnAlarm